"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// Import styles
require("../scss/main.scss");
// Import GSAP and plugins
var gsap_1 = require("gsap");
var ScrollTrigger_1 = require("gsap/ScrollTrigger");
var SplitText_1 = require("gsap/SplitText");
var ScrollToPlugin_1 = require("gsap/ScrollToPlugin");
// Import JS
require("./layout/nav");
require("./components/footer-form");
require("./sections/our-products");
require("./sections/statistics");
require("./sections/testimonials");
require("./sections/film-block");
// Utilities
var hashLinkScroll_1 = require("./utilities/hashLinkScroll");
var animateHeading = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gsap_1.gsap.registerPlugin(SplitText_1.SplitText, ScrollTrigger_1.ScrollTrigger);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Promise.race([
                        document.fonts.ready,
                        new Promise(function (resolve) { return setTimeout(resolve, 3000); }) // 3 second timeout
                    ])];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.warn('Font loading timed out, proceeding with animations');
                return [3 /*break*/, 4];
            case 4:
                // Grab every heading we want to animate
                gsap_1.gsap.utils.toArray(".animate-heading").forEach(function (heading) {
                    // Split just this heading into word spans
                    var splitText = new SplitText_1.SplitText(heading, { type: "words" });
                    var words = splitText.words;
                    // Create a timeline tied to this heading's scroll position
                    var tl = gsap_1.gsap.timeline({
                        scrollTrigger: {
                            trigger: heading, // use the heading itself
                            start: "top 90%", // when top of heading hits 90% from top
                            toggleActions: "play none none none", // play on enter
                            // markers:       true,               
                        }
                    });
                    // Animate the words in
                    tl.from(words, {
                        opacity: 0,
                        y: 50,
                        duration: 1,
                        ease: "power2.out",
                        stagger: 0.1,
                    });
                });
                return [2 /*return*/];
        }
    });
}); };
var animateBlock = function () {
    gsap_1.gsap.utils.toArray(".animate-block").forEach(function (block) {
        var tl = gsap_1.gsap.timeline({
            scrollTrigger: {
                trigger: block,
                start: "top 80%",
                toggleActions: "play none none none"
            }
        });
        tl.from(block, {
            opacity: 0,
            duration: 1.5,
            ease: "power2.out"
        })
            .from(block, {
            y: 50,
            duration: 1,
            ease: "power2.out"
        }, 0 // ← this offset makes it start at the same time as the opacity animation
        );
    });
};
var handleScrollToURL = function () {
    gsap_1.gsap.registerPlugin(ScrollToPlugin_1.ScrollToPlugin);
    var scrollToURLParam = new URLSearchParams(window.location.search).get('scrollTo');
    if (scrollToURLParam) {
        var targetElement_1 = document.querySelector("#".concat(scrollToURLParam));
        if (targetElement_1) {
            setTimeout(function () {
                gsap_1.gsap.to(window, { duration: 2, scrollTo: { y: targetElement_1.offsetTop - 80, autoKill: true }, ease: "power2.inOut" });
            }, 1000); // Delay to ensure the page is fully loaded
        }
    }
};
var scrollToTrigger = function () {
    var scrollToTrigger = document.querySelectorAll('.register-interest-trigger');
    if (scrollToTrigger.length === 0) {
        return; // No triggers found, exit early
    }
    // Add click event listeners to each trigger
    scrollToTrigger.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            var targetId = trigger.getAttribute('data-trigger-target');
            var targetElement = document.querySelector("#".concat(targetId));
            if (targetElement) {
                gsap_1.gsap.to(window, { duration: 2, scrollTo: { y: targetElement.offsetTop - 80, autoKill: true }, ease: "power2.inOut" });
            }
        });
    });
};
var isMobileDevice = function () {
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    isMobile === true ? document.body.classList.add('mobile-device') : document.body.classList.remove('mobile-device');
    // console.log(isMobile);
};
document.addEventListener('DOMContentLoaded', function () {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, animateHeading()];
                case 1:
                    _a.sent();
                    animateBlock();
                    handleScrollToURL();
                    scrollToTrigger();
                    (0, hashLinkScroll_1.initHashLinkScroll)();
                    (0, hashLinkScroll_1.handleHashOnHomepage)();
                    return [2 /*return*/];
            }
        });
    });
});
